import React from 'react'

import { ConfirmationModal, ModalActionTypes } from '@acorns/web-components'
import { getWindow } from '@acorns/web-utils'
import { noop } from 'lodash'

import WarningIcon from 'assets/icons/exclamation-mark-gray-circle.svg'
import { EnvironmentProps, withEnv } from 'utils/environment'

export const SessionHasExpiredModal = withEnv(({ env }: EnvironmentProps) => {
  return (
    <ConfirmationModal
      isOpen={true}
      onRequestClose={noop}
      image={WarningIcon}
      title="Logged Out"
      message="You have been logged out due to inactivity."
      actions={[
        {
          type: ModalActionTypes.primary,
          label: 'Log In',
          handler: () => {
            getWindow().location.replace(env.get('loginUrl'))
          },
        },
      ]}
    />
  )
})
